var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-546.000000, -1869.000000)",
    fill: "#1E1B1B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(541.000000, 1864.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 9.000000) rotate(-315.000000) translate(-9.000000, -9.000000) translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,5.5 L5.5,1.21368294 C5.5,0.937540568 5.72385763,0.713682943 6,0.713682943 C6.27614237,0.713682943 6.5,0.937540568 6.5,1.21368294 L6.5,5.5 L11,5.5 C11.2761424,5.5 11.5,5.72385763 11.5,6 C11.5,6.27614237 11.2761424,6.5 11,6.5 L6.5,6.5 L6.5,11 C6.5,11.2761424 6.27614237,11.5 6,11.5 C5.72385763,11.5 5.5,11.2761424 5.5,11 L5.5,6.5 L1,6.5 C0.723857625,6.5 0.5,6.27614237 0.5,6 C0.5,5.72385763 0.723857625,5.5 1,5.5 L5.5,5.5 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d65bdfc662286c7f835ea4a78b9cb8c3.svg";
export { ForwardRef as ReactComponent };